/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBandage = createReactComponent("outline", "bandage", "IconBandage", [["path", { "d": "M14 12l0 .01", "key": "svg-0" }], ["path", { "d": "M10 12l0 .01", "key": "svg-1" }], ["path", { "d": "M12 10l0 .01", "key": "svg-2" }], ["path", { "d": "M12 14l0 .01", "key": "svg-3" }], ["path", { "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7", "key": "svg-4" }]]);

export { IconBandage as default };
//# sourceMappingURL=IconBandage.mjs.map
